<template>
  <q-row
    style="padding: 20px;"
    :gutter="15"
  >
    <q-col :span="11">
      <trusted-permissions
        v-model="currentTrust.trusteeList"
        :trusted="currentTrust"
        :permissions="currentTrust.permissions"
        @update="updateTrustedList"
      />
    </q-col>
    <q-col :span="13">
      <q-input
        v-model="filterText"
        class="search"
        :placeholder="this.$qt('permission.editor.searchPlaceHolder') "
      >
        <q-button
          slot="append"
          icon="q-icon-search"
        />
      </q-input>

      <q-tree
        ref="allTrusted"
        class="filter-tree"
        :data="trustList"
        :props="defaultProps"
        default-expand-all
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
      />
    </q-col>
  </q-row>
</template>

<script>
  import trustedPermissions from './trustedPermissions';

  export default {
    name: "QPermissionEditor",
    components: {
      'trusted-permissions': trustedPermissions
    },

    data() {
      return {
        filterText: '',
        trustList: [],
        currentTrust: {},
        defaultProps: {
          children: 'children',
          label: 'caption'
        }
      }
    },
    watch: {
      filterText(val) {
        this.$refs.allTrusted.filter(val);
      }
    },

    mounted() {
      this.$delegate('gausaka', 'fetchTrustedList', {}).then((res) => {
        this.trustList = res.result.models;
        this.message = res.message;
        this.title = '';

        this.$eventHub.$emit("onPageChanging", {
          caption: 'Permission Editor',
          note: 'Per Edt'
        })
      }).catch(() => {
      });
    },
    methods: {
      updateTrustedList() {
        this.$delegate('gausaka', 'updateTrustedList', {
          editedModels: this.trustList
        }).then((res) => {

          this.$notify({
            title: this.$qt('model.successPersistTitle'),
            message: res.message,
            type: 'success'
          });


        }).catch(() => {
        });
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.caption.indexOf(value) !== -1;
      },
      handleNodeClick(data) {
        this.currentTrust = data;
      }
    }
  }
</script>

<style scoped>

</style>